import React from 'react';
import { flavors } from '../mock';
import { ArrowUpRight } from 'lucide-react';

const Flavors = () => {
  return (
    <section id="flavors" className="px-5 md:px-8 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-[#E63946]">Pick your mood</div>
            <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] mt-2">
              What are you<br />crunching today?
            </h2>
          </div>
          <p className="font-brico max-w-sm text-lg">Four flavor worlds. Zero boring bites. Slide, tap and pick your crunch.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {flavors.map((f, i) => (
            <div key={f.id} className="group relative overflow-hidden rounded-3xl crunch-shadow bg-white cursor-pointer transition-transform hover:-translate-y-1" style={{ backgroundColor: f.bg }}>
              <div className="p-5 pb-2 flex items-center justify-between">
                <span className="text-xs font-bold uppercase tracking-widest">I want</span>
                <span className="w-9 h-9 rounded-full bg-white flex items-center justify-center crunch-shadow-sm group-hover:rotate-45 transition-transform">
                  <ArrowUpRight size={16} />
                </span>
              </div>
              <div className="px-5 pb-8">
                <h3 className="font-display text-5xl uppercase" style={{ color: f.color }}>{f.title}</h3>
                <p className="text-sm font-brico mt-1 opacity-70">{f.subtitle}</p>
              </div>
              <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/70 flex items-center justify-center text-xs font-bold">{String(i + 1).padStart(2, '0')}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Flavors;
